import axios from "axios"
import { SALDOS } from "../constants/service-resources"
import IResumenMetodoES from "../interfaces/service/models/IResumenMetodoES"

export async function getSaldos(){
    const result = await axios.get<IResumenMetodoES[]>(SALDOS)
    return result.data
}